import type React from "react";
import type { ReactNode } from "react";
import { DealHistoryRow } from "~/components/common/deals/show/main/histories/DealHistoryRow";
import { useDealHistories } from "~/hooks/vendors/deals/useDealHistories";
import type { DealHistory } from "~/models/DealHistory";

type Props = {
	dealId: number;
};

const renderRow = (history: DealHistory): ReactNode => (
	<DealHistoryRow dealHistory={history} key={history.id} />
);

/**
 *
 * @param dealId
 * @constructor
 * @for vendor
 */
export const DealHistoryVendorList: React.FC<Props> = ({ dealId }: Props) => {
	const { data: histories } = useDealHistories().useIndex(dealId);
	if (histories === null) {
		return null;
	}
	return <div>{histories.map(renderRow)}</div>;
};
